'use client';

import { useViewport, useViewportMetrics } from '@/hooks/dom';
import { Viewport } from '@/theme/breakpoints';

export function useCwitnesscardmodalLayout() {
  const { viewport } = useViewport();
  const { vh } = useViewportMetrics();

  return {
    isMobile: viewport === Viewport.Mobile,
    vh,
  };
}
